export { awaitGlobal } from './await-global';
